import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
const KEY = "nasdeal_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (p, qty = 1) => {
    if (p.stock <= 0) return;
    setItems((prev) => {
      const max = Math.min(p.stock, 20);
      const ex = prev.find((i) => i.product_id === p.id);
      if (ex) return prev.map((i) => (i.product_id === p.id ? { ...i, quantity: Math.min(i.quantity + qty, max) } : i));
      return [...prev, { product_id: p.id, slug: p.slug, name: p.name, price: p.price, image: p.images?.[0],
        volume_ml: p.volume_ml, stock: p.stock, quantity: Math.min(qty, max) }];
    });
    toast.success(`${p.name} ajouté au panier`);
    setOpen(true);
  };
  const update = (id, q) =>
    setItems((prev) => prev.map((i) => (i.product_id === id ? { ...i, quantity: Math.max(1, Math.min(q, i.stock || 20, 20)) } : i)));
  const remove = (id) => setItems((prev) => prev.filter((i) => i.product_id !== id));
  const clear = () => setItems([]);

  const value = useMemo(() => ({
    items, add, update, remove, clear, open, setOpen,
    count: items.reduce((s, i) => s + i.quantity, 0),
    subtotal: Math.round(items.reduce((s, i) => s + i.price * i.quantity, 0) * 100) / 100,
  }), [items, open]); // eslint-disable-line react-hooks/exhaustive-deps

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
